WiseMetering.Views.OrganizationSpecialFeaturesAccordion = Backbone.Marionette.ItemView.extend({
    template: 'templates/organizations/special_features_accordion',

    modelEvents: {
        'change': 'render'
    },

    onShow: function() {
        // the credit fields only come in the show payload, the boot data carries the index view
        this.model.fetch();
    },

    events: {
        'click #edit_special_features_attributes': 'editAttributes'
    },

    serializeData: function() {
        const json = this.model.toJSON();
        json.hasSpecialFeatures = this.model.hasSpecialFeatures();
        json.showLlmCredits = WiseMetering.currentUser.isSuperUser() && json.llm_credits_left_percentage !== undefined;
        return json;
    },

    editAttributes: function(event) {
        event.stopPropagation();
        new WiseMetering.Views.EditSpecialFeaturesOrganization({ model: this.model });
    }
});
